module.exports = __webpack_public_path__ + "static/img/dd-partner-02.9b753fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-partner-02.jpg
// module id = L6Xs
// module chunks = 1